import { Stack } from '@common/ui'
import { com } from '@eidu/web'
import EntityFormInput from '../../../../components/input/EntityFormInput'
import DraftFieldValue from '../../../../domain/entity/DraftFieldValue'
import FieldId = com.eidu.entity.field.FieldId
import EntityTypeId = com.eidu.entity.type.EntityTypeId
import EntityType = com.eidu.entity.type.EntityType

type EntityFieldInputGroupProps = {
  entityType: EntityType
  entityTypes: ReadonlyMap<EntityTypeId, EntityType>
  fields: ReadonlyMap<FieldId, DraftFieldValue>
  updateField: (value: DraftFieldValue) => void
  loading: boolean
}

const EntityFieldInputGroup = ({
  entityType,
  entityTypes,
  fields,
  updateField,
  loading,
}: EntityFieldInputGroupProps) => (
  <Stack gap="lg">
    {entityType.fields.asJsReadonlyArrayView().map((field) => (
      <EntityFormInput
        key={`entity-form-field-${field.id.toString()}`}
        field={field}
        fieldValue={fields.get(field.id)}
        entityTypes={entityTypes}
        updateField={updateField}
        loading={loading}
      />
    ))}
  </Stack>
)

export default EntityFieldInputGroup
